<template>
  <li>
    <div class="li">
      <img
        v-if="enableCheck"
        class="selectRadio"
        @click="handleSelect(item, index)"
        :src="item.check ? require('../assets/newicon/xuanzhong.png') : require('../assets/newicon/weixuanzhong.png')"
      />
      <div class="box">
        <img
          :src="item.ImgUrlOne ? item.ImgUrlOne : require('../assets/pingzi/zhanweitu@2x.png')"
          :onerror="'this.src=\'' + require('../assets/pingzi/error-zhanweitu@2x.png') + '\''"
          class="img"
          @click="showImg(item)"
        />
        <div class="info">
          <h3>{{ item.ProductName }}</h3>
          <div class="text">
            <span class="brand-text">品牌：{{ item.BrandName }}</span>
            <span class="model-text">型号：{{ item.Model }}</span>
          </div>
          <div class="text" v-p:BrandManufacturerCode v-if="item.BrandManufacturerCode">厂商编码：{{ item.BrandManufacturerCode }}</div>
          <div class="text" v-p:Specifications v-if="item.Specifications">规格：{{ item.Specifications }}</div>
          <div class="text">
            <div class="price">
              <span>{{ item.Price>0?'¥'+item.Price.toFixed(2): '暂无标价' }}</span>
              <span v-p:SaleNum>
                <template v-if="(item.StoreNum==0&&IndexStore.state.wareHouseValue==1) || (item.StoreNum==0&&item.Price<=0)">
                  不可以订货
                </template>
                <template v-else-if="item.StoreNum==0&&item.Price>0">
                  可以订货
                </template>
                <template v-else>
                  {{ '可售库存：'+item.StoreNum }}
                </template>
                
              </span>
              
            </div>
          </div>
          <div v-if="isAddCart" @click="handleAddCart(item, index)" style="font-size:12px">加入购物车</div>
          <div class="text flex">
            <van-button
              @click="handleShow(item)"
              v-if="lv === 1 && item.list.length > 0"
              class="huhuan-button van-button--mini"
               plain type="primary"
            >
              互换产品
            </van-button>
            <div class="pro-locationName text" v-if="item.LocationName">货位：{{item.LocationName}}</div>
            <CustomStepper :service="item" v-model="item.num" />
          </div>
          <div class="pro-remark" v-if="item.remark">描述：{{item.remark}}</div>
        </div>
      </div>
    </div>
    <div v-if="lv === 1 && item.showList" class="list subList">
      <!-- <div class="huan-text">互换产品</div> -->
      <ul>
        <buy-car-item
          :index="index2"
          :item="item2"
          v-for="(item2, index2) of item.list"
          :key="index2"
          :enableCheck="enableCheck"
          :isAddCart="isAddCart"
          @handleSelect="handleSelect.apply(this, $event)"
          @handleJian="handleJian.apply(this, $event)"
          @inputFocus="inputFocus.apply(this, $event)"
          @handleAdd="handleAdd.apply(this, $event)"
          @handleShow="handleShow.apply(this, $event)"
        ></buy-car-item> 
      </ul>
    </div>
  </li>
</template>

<script>
import CustomStepper from "./CustomStepper";
import { ImagePreview } from 'vant';
import IndexStore from "../store/Index";
export default {
  name: "buy-car-item",
  components: { 
    CustomStepper,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  props: {
    enableCheck: Boolean,
    item: Object,
    index: Number,
    lv: Number,
    wareHouseType:Number,
    isAddCart: Boolean
  },
  data(){
    return{
      IndexStore
    }
  },
  computed: {},
  created(){
    console.log(this.wareHouseType);
  },
  methods: {
    handleSelect() {
      this.$emit("handleSelect", arguments);
    },
    handleJian() {
      this.$emit("handleJian", arguments);
    },
    inputFocus() {
      this.$emit("inputFocus", arguments);
    },
    handleAdd() {
      this.$emit("handleAdd", arguments);
    },
    handleShow() {
      this.$emit("handleShow", arguments);
    },
    handleAddCart(){
      this.$emit("handleAddCart", arguments);
    },
    showImg(item){
      if(item.ImgUrlOne){
        ImagePreview({
          images: [item.ImgUrlOne]
        });
      }
      
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/activityBills.scss";
</style>
